import { Component, inject } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

import { MenuService, ScreenSizeService } from '../../../../services';
import { FormlyService } from '../../../../services/component-services/formly.service';

@Component({
  selector: 'app-formly-horizontal-wrapper',
  templateUrl: './horizontal-wrapper.component.html',
  styleUrl: './horizontal-wrapper.component.scss',
  imports: [FormlyModule],
})
export class FormlyHorizontalWrapperComponent extends FieldWrapper {
  protected readonly menuService = inject(MenuService);
  protected readonly screenSizeService = inject(ScreenSizeService);
  private readonly formlyService = inject(FormlyService);

  get isMobile() {
    return this.formlyService.isMobile;
  }

  get isTextArea(): boolean {
    return this.field.type === 'textarea';
  }
}
